// Extract YouTube video ID from various URL formats
const YT_REGEX =
  /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|v\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export const extractYouTubeId = (url) => {
  if (!url) return null;
  const m = String(url).match(YT_REGEX);
  return m ? m[1] : null;
};

export const youtubeThumb = (id, quality = "hqdefault") =>
  id ? `https://i.ytimg.com/vi/${id}/${quality}.jpg` : null;

export const youtubeEmbed = (id) =>
  id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
